import { FieldProps } from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import {
  IFormServer,
  IFieldLevelRuleConditionClient,
  IFieldLevelRuleClient,
  IPageLevelRuleConditionClient,
  IFormLevelRuleClient,
  IFormLevelRuleConditionClient,
  ISubmissionLevelRuleConditionClient,
  ISubmissionLevelRuleClient,
  IDoublePanelLevelRuleClient,
} from "@common/redux/forms/interface";
import {
  IForm,
  IShowFieldEditorActionSelector,
  IUpdateIsFocusAction,
  IPopulateNewFieldConfig,
  IPopulateNewSectionConfig,
  ISetActiveFormAction,
  IChangeFieldPositionAction,
  IChangeFieldPositionActionPayload,
  ISubForm,
  IAdvancedRulesServer,
  IUpdateFieldRulePayload,
  ISetActiveRuleAction,
  IAddFieldConditionAction,
  IDeleteFieldConditionAction,
  IUpdateFieldsToIgnoreActionPayload,
  IAddNewSubRuleAction,
  IFieldsToHIdeAndShow,
  IValidateFieldRule,
  ICopySectionActionPayload,
  IUpdatePageRulePayload,
  IPageToHIdeAndShow,
  IUpdatePagesToIgnoreActionPayload,
  IAddPageConditionAction,
  IDeletePageConditionAction,
  IUpdateFormRulePayload,
  IAddFormConditionAction,
  IUpdateFormFieldsToIgnoreActionPayload,
  IDeleteFormConditionAction,
  IAutoSaveFormLocallyAction,
  ISetAutoSavedFormToFormbuilder,
  ISetFormIsEditingAction,
  IFieldsMap,
  IAddSubmissionConditionAction,
  IDeleteSubmissionConditionAction,
  IUpdateSubmissionRulePayload,
  IModalData,
  submisionType,
  ISetActiveSubmissionTypeAction,
  IFieldLoaderMap,
  IGetSignatureFormFilesAction,
  IGetSignatureFormFilesActionPayload,
  IFormLockData,
  IFetchApplicationPage,
  IFetchApplicationPayload,
  ISetFormMode,
} from "@common/redux/formBuilder/interface";
import { IPageLevelRuleClient } from "@presentation/FormBuilder/components/ConfiguredRule/interface";
import { IFieldSubmissionMap } from "../formSubmission/interface";
import { FormModes } from "@presentation/FormBuilder/components/DescriptionField/utils";
const actionTypePrefix = "FORM_BUILDER/";

export const formBuilderActions = {
  ADD_NEW_FIELD: `${actionTypePrefix}ADD_NEW_FIELD`,
  ADD_NEW_SECTION: `${actionTypePrefix}ADD_NEW_SECTION`,
  FOCUS_FIELD: `${actionTypePrefix}FOCUS_FIELD`,
  COPY_FIELD: `${actionTypePrefix}COPY_FIELD`,
  COPY_SECTION: `${actionTypePrefix}COPY_SECTION`,
  DELETE_FIELD: `${actionTypePrefix}DELETE_FIELD`,
  UPDATE_FIELD_DATA: `${actionTypePrefix}UPDATE_FIELD_DATA`,
  UPDATE_FIELDS_MAP: `${actionTypePrefix}UPDATE_FIELDS_MAP`,

  INITIALIZE_FIELD_DATA: `${actionTypePrefix}INITIALIZE_FIELD_DATA`,

  CHANGE_FIELD_TYPE: `${actionTypePrefix}CHANGE_FIELD_TYPE`,
  UPDATE_FIELD_POSITION: `${actionTypePrefix}UPDATE_FIELD_POSITION`,
  UPDATE_DATA_FORM_DATA: `${actionTypePrefix}UPDATE_DATA_FORM_DATA`,

  ADD_NEW_SUB_FORM: `${actionTypePrefix}ADD_NEW_SUB_FORM`,
  DELETE_SUB_FORM: `${actionTypePrefix}DELETE_SUB_FORM`,
  UPDATE_SUB_FORM_POSITION: `${actionTypePrefix}UPDATE_SUB_FORM_POSITION`,
  UPDATE_SUB_FORM_DATA: `${actionTypePrefix}UPDATE_SUB_FORM_DATA`,

  SET_ACTIVE_FORM: `${actionTypePrefix}SET_ACTIVE_FORM`,
  SET_ACTIVE_FORM_SUCCESS: `${actionTypePrefix}SET_ACTIVE_FORM_SUCCESS`,
  SET_ACTIVE_FORM_FAILURE: `${actionTypePrefix}SET_ACTIVE_FORM_FAILURE`,

  SET_ACTIVE_FORM_EDIT_CONFIG: `${actionTypePrefix}SET_ACTIVE_FORM_EDIT_CONFIG`,
  SHOW_FIELD_EDITOR: `${actionTypePrefix}SHOW_FIELD_EDITOR`,

  POPULATE_NEW_FIELD_CONFIG: `${actionTypePrefix}POPULATE_NEW_FIELD_CONFIG`,
  POPULATE_NEW_SECTION_CONFIG: `${actionTypePrefix}POPULATE_NEW_SECTION_CONFIG`,

  CHANGE_FIELD_POSITION: `${actionTypePrefix}CHANGE_FIELD_POSITION`,
  CHANGE_FIELD_POSITION_SUCCESS: `${actionTypePrefix}CHANGE_FIELD_POSITION_SUCCESS`,
  CHANGE_FIELD_POSITION_FAILURE: `${actionTypePrefix}CHANGE_FIELD_POSITION_FAILURE`,

  UPDATE_FIELD_RULE: `${actionTypePrefix}UPDATE_FIELD_RULE`,
  ADD_NEW_FIELD_RULE: `${actionTypePrefix}ADD_NEW_FIELD_RULE`,
  UPDATE_PAGE_RULE: `${actionTypePrefix}UPDATE_PAGE_RULE`,
  UPDATE_FORM_RULE: `${actionTypePrefix}UPDATE_FORM_RULE`,
  ADD_NEW_PAGE_RULE: `${actionTypePrefix}ADD_NEW_PAGE_RULE`,
  ADD_NEW_FORM_RULE: `${actionTypePrefix}ADD_NEW_FORM_RULE`,
  UPDATE_PAGE_CONDITION: `${actionTypePrefix}UPDATE_PAGE_CONDITION`,
  UPDATE_FORM_CONDITION: `${actionTypePrefix}UPDATE_FORM_CONDITION`,
  ADD_PAGE_CONDITION: `${actionTypePrefix}ADD_PAGE_CONDITION`,
  ADD_FORM_CONDITION: `${actionTypePrefix}ADD_FORM_CONDITION`,
  DELETE_PAGE_CONDITION: `${actionTypePrefix}DELETE_PAGE_CONDITION`,
  DELETE_FORM_CONDITION: `${actionTypePrefix}DELETE_FORM_CONDITION`,
  SET_ACTIVE_RULE: `${actionTypePrefix}SET_ACTIVE_RULE`,
  UPDATE_FIELD_CONDITION: `${actionTypePrefix}UPDATE_FIELD_CONDITION`,
  ADD_FIELD_CONDITION: `${actionTypePrefix}ADD_FIELD_CONDITION`,
  DELETE_FIELD_CONDITION: `${actionTypePrefix}DELETE_FIELD_CONDITION`,
  ADD_SUBMISSION_CONDITION: `${actionTypePrefix}ADD_SUBMISSION_CONDITION`,
  DELETE_SUBMISSION_CONDITION: `${actionTypePrefix}DELETE_SUBMISSION_CONDITION`,
  UPDATE_SUBMISSION_CONDITION: `${actionTypePrefix}UPDATE_SUBMISSION_CONDITION`,
  ADD_NEW_SUBMISSION_RULE: `${actionTypePrefix}ADD_NEW_SUBMISSION_RULE`,
  UPDATE_SUBMISSION_RULE: `${actionTypePrefix}UPDATE_SUBMISSION_RULE`,
  SET_ACTIVE_SUBMISSION_RULE_INDEX: `${actionTypePrefix}SET_ACTIVE_SUBMISSION_RULE_INDEX`,
  DOUBLE_PANEL_RULE_INDEX: `${actionTypePrefix}DOUBLE_PANEL_RULE_INDEX`,
  UPDATE_FIELDS_TO_IGNORE: `${actionTypePrefix}UPDATE_FIELDS_TO_IGNORE`,
  UPDATE_PAGES_TO_IGNORE: `${actionTypePrefix}UPDATE_PAGES_TO_IGNORE`,
  UPDATE_FORM_FIELDS_TO_IGNORE: `${actionTypePrefix}UPDATE_FORM_FIELDS_TO_IGNORE`,
  UPDATE_FIELDS_USED_IN_ACTION: `${actionTypePrefix}UPDATE_FIELDS_USED_IN_ACTION`,

  ADD_NEW_SUB_RULE: `${actionTypePrefix}ADD_NEW_SUB_RULE`,
  SET_ACTIVE_FIELD_RULE_INDEX: `${actionTypePrefix}SET_ACTIVE_FIELD_RULE_INDEX`,
  SET_ACTIVE_PAGE_RULE_INDEX: `${actionTypePrefix}SET_ACTIVE_PAGE_RULE_INDEX`,
  SET_ACTIVE_FORM_RULE_INDEX: `${actionTypePrefix}SET_ACTIVE_FORM_RULE_INDEX`,

  VALIDATE_FIELD_RULE: `${actionTypePrefix}VALIDATE_FIELD_RULE`,
  SET_ACTIVE_SUBMISSION_TYPE: `${actionTypePrefix}SET_ACTIVE_SUBMISSION_TYPE`,
  SET_FIELD_TO_SHOW_AND_HIDE: `${actionTypePrefix}SET_FIELD_TO_SHOW_AND_HIDE`,
  SET_PAGE_TO_SHOW_AND_HIDE: `${actionTypePrefix}SET_PAGE_TO_SHOW_AND_HIDE`,
  SET_MODAL_DATA: `${actionTypePrefix}SET_MODAL_DATA`,
  UPDATE_THEME_ID: `${actionTypePrefix}UPDATE_THEME_ID`,

  UPDATE_ACTIVE_SUBFORM: `${actionTypePrefix}UPDATE_ACTIVE_SUBFORM`,

  AUTO_SAVE_FORM_LOCALLY: `${actionTypePrefix}AUTO_SAVE_FORM_LOCALLY`,
  SET_AUTO_SAVED_FORM_TO_FORMBUILDER: `${actionTypePrefix}SET_AUTO_SAVED_FORM_TO_FORMBUILDER`,
  SET_FORM_IS_EDITING: `${actionTypePrefix}SET_FORM_IS_EDITING`,
  SET_FIELD_LOADER_MAP: `${actionTypePrefix}SET_FIELD_LOADER_MAP`,
  SET_HIDDEN_FIELD: `${actionTypePrefix}SET_HIDDEN_FIELD`,

  GET_SIGNATURE_FORM_FILES: `${actionTypePrefix}GET_SIGNATURE_FORM_FILES`,

  UPDATE_FORM_LOCK_DATA: `${actionTypePrefix}UPDATE_FORM_LOCK_DATA`,
  ONLOAD_UPDATE_FORM_LOCK_DATA: `${actionTypePrefix}ONLOAD_UPDATE_FORM_LOCK_DATA`,
  SET_MULTI_FORM_VERTICAL: "SET_MULTI_FORM_VERTICAL",
  FETCH_APPLICATION_PAGE: `${actionTypePrefix}FETCH_APPLICATION_PAGE`,

  SET_FORM_MODE: `${actionTypePrefix}SET_FORM_MODE`
};

export const fetchApplicationPage = (
  data: IFetchApplicationPayload
): IFetchApplicationPage => {
  return {
    type: formBuilderActions.FETCH_APPLICATION_PAGE,
    payload: data,
  };
};

export const setFormMode = (
  mode: FormModes
): ISetFormMode => {
  return {
    type: formBuilderActions.SET_FORM_MODE,
    payload: mode,
  };
};


export const addNewSubFormFieldAction = (
  index: number,
  fieldId: string,
  formId?: string
) => {
  return {
    type: formBuilderActions.ADD_NEW_FIELD,
    payload: {
      index,
      fieldId,
      formId,
    },
  };
};
export const updateThemeId = (themeId: string) => {
  return {
    type: formBuilderActions.UPDATE_THEME_ID,
    payload: {
      themeId,
    },
  };
};
export const copySubFormFieldAction = (
  index: number,
  fieldId: string,
  formId: string
) => {
  return {
    type: formBuilderActions.COPY_FIELD,
    payload: {
      index,
      fieldId,
      formId,
    },
  };
};

export const addNewSectionAction = (
  index: number,
  fieldId: string,
  formId?: string
) => {
  return {
    type: formBuilderActions.ADD_NEW_SECTION,
    payload: {
      index,
      fieldId,
      formId,
    },
  };
};

export const deleteSubFormFieldAction = (index: number, formId: string) => {
  return {
    type: formBuilderActions.DELETE_FIELD,
    payload: {
      index,
      formId,
    },
  };
};

export const updateFieldDataAction = (fieldData: FieldProps) => {
  //remove index
  return {
    type: formBuilderActions.UPDATE_FIELD_DATA,
    payload: {
      data: fieldData,
    },
  };
};

export const updateFieldsMapAction = (fieldsMap: IFieldsMap) => {
  return {
    type: formBuilderActions.UPDATE_FIELDS_MAP,
    payload: {
      data: fieldsMap,
    },
  };
};
export const updateSubFormDataAction = (formData: ISubForm) => {
  return {
    type: formBuilderActions.UPDATE_SUB_FORM_DATA,
    payload: {
      data: formData,
    },
  };
};

export const changeFieldTypeAction = (fieldData: FieldProps) => {
  return {
    type: formBuilderActions.CHANGE_FIELD_TYPE,
    payload: {
      data: fieldData,
    },
  };
};

export const updatedataFormDataAction = (formData: IForm) => {
  return {
    type: formBuilderActions.UPDATE_DATA_FORM_DATA,
    payload: {
      data: formData,
    },
  };
};

export const addNewSubFormAction = (position: number, formId: string) => {
  return {
    type: formBuilderActions.ADD_NEW_SUB_FORM,
    payload: {
      index: position,
      formId: formId,
    },
  };
};

export const deleteSubFormAction = (index: number) => {
  return {
    type: formBuilderActions.DELETE_SUB_FORM,
    payload: {
      index,
    },
  };
};

export const populateSubFormInitialValuesAction = (
  //remove
  forms: string[],
  fieldsMap: object,
  formsMap: object,
  overviewForm?: string[],
  initialSettings?: object
) => {
  return {
    type: formBuilderActions.INITIALIZE_FIELD_DATA,
    payload: {
      forms,
      fieldsMap: fieldsMap,
      formsMap: formsMap,
      overviewForm: overviewForm,
      initialSettings: initialSettings,
    },
  };
};

export const updateFieldPositionAction = (
  currentPosition: number,
  newPosition: number,
  formId: string
) => {
  return {
    type: formBuilderActions.UPDATE_FIELD_POSITION,
    payload: {
      currentPosition,
      newPosition,
      formId,
    },
  };
};

export const updateSubFormPositionAction = (
  currentPosition: number,
  newPosition: number
) => {
  return {
    type: formBuilderActions.UPDATE_SUB_FORM_POSITION,
    payload: {
      currentPosition,
      newPosition,
    },
  };
};

export const updateIsFocusAction = (payload: IUpdateIsFocusAction) => {
  return {
    type: formBuilderActions.FOCUS_FIELD,
    payload,
  };
};

export const setActiveFormAction = (
  formData: IFormServer
): ISetActiveFormAction => {
  return {
    type: formBuilderActions.SET_ACTIVE_FORM,
    payload: {
      formData: formData,
    },
  };
};

export const setActiveFormSuccessAction = (formData: IForm) => {
  return {
    type: formBuilderActions.SET_ACTIVE_FORM_SUCCESS,
    payload: {
      formData: formData,
    },
  };
};

export const setActiveFormFailureAction = (error: string) => {
  return {
    type: formBuilderActions.SET_ACTIVE_FORM_FAILURE,
    payload: {
      error,
    },
  };
};

export const showFieldEditorAction = (
  payload: IShowFieldEditorActionSelector
) => {
  return {
    type: formBuilderActions.SHOW_FIELD_EDITOR,
    payload,
  };
};
export const populateNewFieldConfigAction = (
  payload: IPopulateNewFieldConfig
) => {
  return {
    type: formBuilderActions.POPULATE_NEW_FIELD_CONFIG,
    payload,
  };
};

export const populateNewSectionConfigAction = (
  payload: IPopulateNewSectionConfig
) => {
  return {
    type: formBuilderActions.POPULATE_NEW_SECTION_CONFIG,
    payload,
  };
};

export const ChangeFieldPositionAction = (
  payload: IChangeFieldPositionActionPayload
): IChangeFieldPositionAction => {
  return {
    type: formBuilderActions.CHANGE_FIELD_POSITION,
    payload,
  };
};

export const ChangeFieldPositionSuccessAction = (formData: IForm) => {
  return {
    type: formBuilderActions.CHANGE_FIELD_POSITION_SUCCESS,
    payload: {
      formData: formData,
    },
  };
};

export const ChangeFieldPositionFailureAction = (error: string) => {
  return {
    type: formBuilderActions.SET_ACTIVE_FORM_FAILURE,
    payload: {
      error,
    },
  };
};

export const updatefieldRuleAction = ({
  position,
  fieldRule,
}: IUpdateFieldRulePayload) => {
  return {
    type: formBuilderActions.UPDATE_FIELD_RULE,
    payload: {
      position,
      fieldRule,
    },
  };
};

export const setActiveRulesAction = (
  ruleData: IAdvancedRulesServer
): ISetActiveRuleAction => {
  return {
    type: formBuilderActions.SET_ACTIVE_RULE,
    payload: {
      ruleData,
    },
  };
};

export const addNewFieldRuleAction = (fieldRule: IFieldLevelRuleClient) => {
  return {
    type: formBuilderActions.ADD_NEW_FIELD_RULE,
    payload: {
      fieldRule,
    },
  };
};

export const updateFieldConditionAction = (
  fieldCondition: IFieldLevelRuleConditionClient
) => {
  return {
    type: formBuilderActions.UPDATE_FIELD_CONDITION,
    payload: {
      fieldCondition,
    },
  };
};
export const updatePageConditionAction = (
  pageCondition: IPageLevelRuleConditionClient
) => {
  return {
    type: formBuilderActions.UPDATE_PAGE_CONDITION,
    payload: {
      pageCondition,
    },
  };
};

export const updateFormConditionAction = (
  formCondition: IFormLevelRuleConditionClient
) => {
  return {
    type: formBuilderActions.UPDATE_FORM_CONDITION,
    payload: {
      formCondition,
    },
  };
};

export const addNewPageRuleAction = (pageRule: IPageLevelRuleClient) => {
  return {
    type: formBuilderActions.ADD_NEW_PAGE_RULE,
    payload: {
      pageRule,
    },
  };
};

export const addNewFormRuleAction = (formRule: IFormLevelRuleClient) => {
  return {
    type: formBuilderActions.ADD_NEW_FORM_RULE,
    payload: {
      formRule,
    },
  };
};

export const addDoublePanelAction = (
  doublePanelRule: IDoublePanelLevelRuleClient
) => {
  return {
    type: formBuilderActions.DOUBLE_PANEL_RULE_INDEX,
    payload: {
      doublePanelRule,
    },
  };
};

export const updatePageRuleAction = ({
  position,
  pageRule,
}: IUpdatePageRulePayload) => {
  return {
    type: formBuilderActions.UPDATE_PAGE_RULE,
    payload: {
      position,
      pageRule,
    },
  };
};
export const updateFormRuleDataAction = ({
  position,
  formRule,
}: IUpdateFormRulePayload) => {
  return {
    type: formBuilderActions.UPDATE_FORM_RULE,
    payload: {
      position,
      formRule,
    },
  };
};
export const addPageConditionAction = (payload: IAddPageConditionAction) => {
  return {
    type: formBuilderActions.ADD_PAGE_CONDITION,
    payload,
  };
};

export const addFormConditionAction = (payload: IAddFormConditionAction) => {
  return {
    type: formBuilderActions.ADD_FORM_CONDITION,
    payload,
  };
};

export const addSubmissionConditionAction = (
  payload: IAddSubmissionConditionAction
) => {
  return {
    type: formBuilderActions.ADD_SUBMISSION_CONDITION,
    payload,
  };
};

export const deleteSubmissionConditionAction = (
  payload: IDeleteSubmissionConditionAction
) => {
  return {
    type: formBuilderActions.DELETE_SUBMISSION_CONDITION,
    payload,
  };
};
export const updateSubmissionConditionAction = (
  submissionCondition: ISubmissionLevelRuleConditionClient
) => {
  return {
    type: formBuilderActions.UPDATE_SUBMISSION_CONDITION,
    payload: {
      submissionCondition,
    },
  };
};

export const addNewSubmissionRuleAction = (
  submissionRule: ISubmissionLevelRuleClient
) => {
  return {
    type: formBuilderActions.ADD_NEW_SUBMISSION_RULE,
    payload: {
      submissionRule,
    },
  };
};

export const updateSubmissionRuleDataAction = ({
  position,
  submissionRule,
}: IUpdateSubmissionRulePayload) => {
  return {
    type: formBuilderActions.UPDATE_SUBMISSION_RULE,
    payload: {
      position,
      submissionRule,
    },
  };
};

export const setActiveSubmissionRulesIndexAction = (index: number) => {
  return {
    type: formBuilderActions.SET_ACTIVE_SUBMISSION_RULE_INDEX,
    payload: index,
  };
};

export const deletePageConditionAction = (
  payload: IDeletePageConditionAction
) => {
  return {
    type: formBuilderActions.DELETE_PAGE_CONDITION,
    payload,
  };
};

export const deleteFormConditionAction = (
  payload: IDeleteFormConditionAction
) => {
  return {
    type: formBuilderActions.DELETE_FORM_CONDITION,
    payload,
  };
};

export const addFieldConditionAction = (payload: IAddFieldConditionAction) => {
  return {
    type: formBuilderActions.ADD_FIELD_CONDITION,
    payload,
  };
};

export const deleteFieldConditionAction = (
  payload: IDeleteFieldConditionAction
) => {
  return {
    type: formBuilderActions.DELETE_FIELD_CONDITION,
    payload,
  };
};

export const updateFieldsToIgnoreAction = (
  payload: IUpdateFieldsToIgnoreActionPayload
) => {
  return {
    type: formBuilderActions.UPDATE_FIELDS_TO_IGNORE,
    payload,
  };
};

export const updatePagesToIgnoreAction = (
  payload: IUpdatePagesToIgnoreActionPayload
) => {
  return {
    type: formBuilderActions.UPDATE_PAGES_TO_IGNORE,
    payload,
  };
};

export const updateFormFieldsToIgnoreAction = (
  payload: IUpdateFormFieldsToIgnoreActionPayload
) => {
  return {
    type: formBuilderActions.UPDATE_FORM_FIELDS_TO_IGNORE,
    payload,
  };
};

export const updateFieldsUsedInAction = (
  payload: IUpdateFieldsToIgnoreActionPayload
) => {
  return {
    type: formBuilderActions.UPDATE_FIELDS_USED_IN_ACTION,
    payload,
  };
};

export const addNewSubRuleAction = (payload: IAddNewSubRuleAction) => {
  return {
    type: formBuilderActions.ADD_NEW_SUB_RULE,
    payload,
  };
};

export const setActiveFieldRulesIndexAction = (index: number) => {
  return {
    type: formBuilderActions.SET_ACTIVE_FIELD_RULE_INDEX,
    payload: index,
  };
};

export const setActivePageRulesIndexAction = (index: number) => {
  return {
    type: formBuilderActions.SET_ACTIVE_PAGE_RULE_INDEX,
    payload: index,
  };
};

export const setActiveFormRulesIndexAction = (index: number) => {
  return {
    type: formBuilderActions.SET_ACTIVE_FORM_RULE_INDEX,
    payload: index,
  };
};

export const setActiveSubmissionTypeAction = (
  submissionType?: submisionType
): ISetActiveSubmissionTypeAction => {
  return {
    type: formBuilderActions.SET_ACTIVE_SUBMISSION_TYPE,
    payload: { submissionType },
  };
};

export const validateFieldRuleAction = (
  fieldId: string,
  submissionType?: submisionType,
  submissionId?: string,
  submissionMap?: IFieldSubmissionMap
): IValidateFieldRule => {
  return {
    type: formBuilderActions.VALIDATE_FIELD_RULE,
    payload: { fieldId, submissionType, submissionId, submissionMap },
  };
};

export const setFieldToShowAndHideAction = (
  fieldsToHideAndShow: IFieldsToHIdeAndShow
) => {
  return {
    type: formBuilderActions.SET_FIELD_TO_SHOW_AND_HIDE,
    payload: fieldsToHideAndShow,
  };
};

export const setPageToShowAndHideAction = (
  pageToHideAndShow: IPageToHIdeAndShow
) => {
  return {
    type: formBuilderActions.SET_PAGE_TO_SHOW_AND_HIDE,
    payload: pageToHideAndShow,
  };
};

export const setModalData = (modalData: IModalData) => {
  return {
    type: formBuilderActions.SET_MODAL_DATA,
    payload: modalData,
  };
};

export const copySectionAction = (payload: ICopySectionActionPayload) => {
  return {
    type: formBuilderActions.COPY_SECTION,
    payload,
  };
};

export const updateActiveSubformAction = (activeSubform: number) => {
  return {
    type: formBuilderActions.UPDATE_ACTIVE_SUBFORM,
    payload: activeSubform,
  };
};

export const autoSaveFormLocallyAction = (
  isSaved: boolean
): IAutoSaveFormLocallyAction => {
  return {
    type: formBuilderActions.AUTO_SAVE_FORM_LOCALLY,
    payload: {
      isSaved,
    },
  };
};

export const setAutoSavedFormToFormbuilderAction = (
  formData: IForm
): ISetAutoSavedFormToFormbuilder => {
  return {
    type: formBuilderActions.SET_AUTO_SAVED_FORM_TO_FORMBUILDER,
    payload: {
      formData,
    },
  };
};

export const setFormIsEditingAction = (
  isEditing: boolean
): ISetFormIsEditingAction => {
  return {
    type: formBuilderActions.SET_FORM_IS_EDITING,
    payload: {
      isEditing,
    },
  };
};

export const setFieldLoaderMapAction = (payload: IFieldLoaderMap) => {
  return {
    type: formBuilderActions.SET_FIELD_LOADER_MAP,
    payload,
  };
};

export const updateHiddenFieldsData = (updatedHiddenFields) => {
  return {
    type: formBuilderActions.SET_HIDDEN_FIELD,
    payload: {
      updatedHiddenFields: updatedHiddenFields,
    },
  };
};

export const getSignatureFormFilesAction = (
  payload: IGetSignatureFormFilesActionPayload
): IGetSignatureFormFilesAction => {
  return {
    type: formBuilderActions.GET_SIGNATURE_FORM_FILES,
    payload,
  };
};

export const onLoadUpdateFormLockDataAction = (formLockData: IFormLockData) => {
  return {
    type: formBuilderActions.ONLOAD_UPDATE_FORM_LOCK_DATA,
    payload: {
      formLockData: formLockData,
    },
  };
};

export const updateFormLockDataAction = (formLockData: IFormLockData) => {
  return {
    type: formBuilderActions.UPDATE_FORM_LOCK_DATA,
    payload: {
      formLockData: formLockData,
    },
  };
};

export const setMultiFormVertical = (value: boolean) => {
  const action = {
    type: formBuilderActions.SET_MULTI_FORM_VERTICAL,
    payload: {
      isVertical: value,
    },
  };
  return action;
};
